import { inject, Injectable } from "@angular/core";
import { OFState, OfStoreService } from "./of-store.service";
import { EntityFacadeService } from "../../../../shared/store/entity-store/entity-facade.service";
import { EntityMetadata } from "../../../../shared/store/store-types.model";
import { OfApiService } from "./of-api.service";
import { OF } from "../../../of/models/of.model";
import {
  Untrack,
  UpdateStatus,
} from "../../../../shared/store/utils/store-utils.service";
import { firstValueFrom } from "rxjs";
import { OfEtat } from "../../../of/enums/etat-of.enum";

@Injectable({ providedIn: "root" })
export class OfFacadeService extends EntityFacadeService<
  OF,
  OfApiService,
  OFState,
  EntityMetadata,
  OfStoreService
> {
  constructor() {
    const api = inject(OfApiService);
    const store = inject(OfStoreService);
    super(api, store);
    this.store.initStatus(OfFacadeService);
  }

  @Untrack
  @UpdateStatus
  async updateQuantite(ofId: string, quantite: number) {
    const of = await firstValueFrom(this.api.updateQuantite(ofId, quantite));
    this.store.upsertOne(of);
    return of;
  }

  @Untrack
  @UpdateStatus
  async annuler(ofId: string) {
    const of = await firstValueFrom(this.api.annuler(ofId));
    this.store.upsertOne(of);
  }

  @Untrack
  @UpdateStatus
  async planify(ofId: string) {
    const of = await firstValueFrom(this.api.planify(ofId));
    this.store.upsertOne(of);
  }

  @Untrack
  @UpdateStatus
  async loadAllFilter(filters: {
    dluoDates: { start: Date; end: Date };
    ofDates: { start: Date; end: Date };
    etats: OfEtat[];
    lignes: string[];
    search: string;
    sort: string;
    articleId: string;
    page?: number;
  }) {
    const page = filters.page ?? 0;
    if (page === 0) {
      this.store.removeAll();
    }
    const ofs = await firstValueFrom(this.api.loadAllFilter(filters));
    this.store.addMany(ofs);
    return ofs;
  }
}
